<template>
  <div>
    <PageAllow controller="PurchasePlans" action="edit" />
    <Breadcrumbs :items="items" />

    <v-sheet class="transparent-background-color pa-4">
      <v-card>
        <v-card-title class="mx-3">
          {{ $t("PurchasePlans.title") }}
          <v-spacer />
          <v-btn
            v-if="$permission.permissionAllow('PurchasePlans', 'edit')"
            small
            color="primary"
            class="px-2 me-2 mb-1"
            @click.stop="doSubmit()"
          >
            <v-icon x-small class="pe-1">fa-save</v-icon>
            {{ $t("PurchasePlans.actions.editSubmit") }}
          </v-btn>
        </v-card-title>
        <v-divider />
        <v-data-table
          :headers="detailsHeaders"
          :items="purchasePlan.purchase_plan_details"
          disable-sort
          class="elevation-2 px-4 mt-4"
          disable-pagination
          hide-default-footer
          :no-data-text="$t('PurchasesList.intelligent.DetailNoData')"
        >
          <template v-slot:top>
            <v-toolbar flat class="transparent-background-color">
              <v-toolbar-title class="ms-n2">
                {{ purchasePlan && purchasePlan.stock ? purchasePlan.stock.name : "" }}
              </v-toolbar-title>
            </v-toolbar>
            <v-divider />
          </template>
          <!-- 采购订货数 -->
          <template v-slot:item.quantity="{ item }">
            <v-text-field
              single-line
              dense
              hide-details
              v-model="item.quantity"
              type="number"
              min="0"
              @blur="item.quantity = $numberFormatter.formatWithDotNoMoreThan(Number(item.quantity),2);"
              style="max-width: 100px; margin-left: auto"
            >
            </v-text-field>
          </template>
          <template v-slot:item.unit="{ item }">
            <v-autocomplete
              v-model="item.standard_detail_id"
              :items="item.material.standard.standard_details"
              item-text="unit"
              item-value="id"
              unclearable
              style="width: 20px"
            />

          </template>
          <!-- 备注 -->
          <template v-slot:item.memo="{ item }">
            <v-text-field
              v-model="item.memo"
              single-line
              dense
              hide-details
              style="max-width: 200px"
            >
              <template v-slot:append>
                <v-icon
                  x-small
                  @click.stop="
                    detail_memo_item = item;
                    memoDialog = true;
                  "
                  class="pt-2 pb-1 primary--text"
                >
                  fa-edit
                </v-icon>
              </template>
            </v-text-field>
          </template>
        </v-data-table>
      </v-card>
    </v-sheet>
    <v-dialog v-model="noPurchase" width="480px">
      <v-card>
        <v-card-title class="mx-3">
          {{ $t("PurchasesList.intelligent.purchases") }}
          <v-spacer></v-spacer>
          <v-tooltip left>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                v-bind="attrs"
                v-on="on"
                @click="
                  $router.push('/intelligent-purchase');
                "
              >
                fa-times
              </v-icon>
            </template>
            {{ $t("$vuetify.close") }}
          </v-tooltip>
        </v-card-title>
        <v-divider />
        <v-card-text
          class="px-4 py-8 text-center subtitle-1 red--text font-weight-bold"
        >
          {{ $t("PurchasesList.intelligent.noPurchase") }}
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="secondary"
            outlined
            @click="
              $router.push('/intelligent-purchase');
            "
          >
            {{ $t("$vuetify.close") }}
          </v-btn>
          <v-btn
            @click.stop="
              $router.push('/intelligent-purchase/purchase-from-order')
            "
            color="primary"
          >
            {{ $t("PurchasesList.intelligent.jump") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- 备注弹窗 -->
    <v-dialog v-model="memoDialog" max-width="480px">
      <v-card>
        <v-card-title class="mx-3">
          <span class="d-inline-block text-center" style="max-width: 360px">
            {{ $t("financeBillEdit.memo") }}
          </span>
          <v-spacer></v-spacer>
          <v-tooltip left>
            <template v-slot:activator="{ on, attrs }">
              <v-icon v-bind="attrs" v-on="on" @click="memoDialog = false">
                fa-times
              </v-icon>
            </template>
            {{ $t("$vuetify.close") }}
          </v-tooltip>
        </v-card-title>
        <v-divider />
        <v-card-text class="px-4 pt-8">
          <v-textarea
                  v-model="detail_memo_item.memo"
                  outlined
                  :label="$t('Order.DetailFields.memo')"
          />
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn color="secondary" outlined @click="memoDialog = false">
            {{ $t("$vuetify.close") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapState } from "vuex";
import i18n from "@/i18n";
import PageAllow from "@/components/PageAllow";
import Breadcrumbs from "@/components/Breadcrumbs";
import PurchasePlans from "@/api/purchase_plans";

export default {
  components: {
    PageAllow,
    Breadcrumbs,
  },
  computed: {
    items() {
      return [
        {
          text: i18n.t("Nav.home"),
          disabled: false,
          href: "/home",
        },
        {
          text: i18n.t("Nav.purchases"),
          disabled: false,
          href: "/purchases",
        },
        {
          text: i18n.t("Nav.purchasePlans"),
          disabled: false,
          href: "/purchase-plans",
        },
        {
          text: i18n.t("PurchasePlans.editTitle"),
          disabled: true,
          href: "/purchase-plans/purchase-plans-edit",
        },
      ];
    },
    detailsHeaders() {
      let headers = [
        {
          text: i18n.t("PurchasesDetail.purchaseFields.material_code"),
          align: "start",
          sortable: false,
          value: "material.material_code",
        },
        {
          text: i18n.t("PurchasesDetail.purchaseFields.material_name"),
          align: "start",
          sortable: false,
          value: "material.material_name",
        },
        {
          text: i18n.t("PurchasesDetail.purchaseFields.standard_name"),
          align: "start",
          sortable: false,
          value: "standard_name",
        },
        //   采购订货数
        {
          text: i18n.t("PurchasesDetail.purchaseFields.quantity"),
          align: "center",
          sortable: false,
          width: "150",
          value: "quantity",
        },
        {
          text: i18n.t("PurchasesDetail.purchaseFields.unit"),
          align: "start",
          sortable: false,
          value: "unit",
        },
        // 备注
        {
          text: i18n.t("PurchasesDetail.purchaseFields.memo"),
          align: "center",
          sortable: false,
          width: "200",
          value: "memo",
        }
      ];
      return headers;
    },
    locale() {
      return this.$i18n.locale != "zhHans";
    },
    // 使用对象展开运算符将此对象混入到外部对象中
    ...mapState(["settings", "accountUser"]),
  },

  data: () => ({
    purchasePlan: [],
    noPurchase: false,
    detail_memo_item: { memo: "" },
    memoDialog: false,
    is_loss: false,
  }),

  mounted() {
    this.getPurchaseableDetails();
  },

  methods: {
    getPurchaseableDetails() {
      PurchasePlans.fetchOne(this.$route.params.id).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.is_loss = response.data.is_loss;
            this.purchasePlan = response.data.purchase_plan;
          }
        }.bind(this)
      );
    },
    //整理预览提交数据
    doSubmitData() {
      let postData = {
        id: this.purchasePlan.id,
        purchase_plan_details: []
      }
      this.purchasePlan.purchase_plan_details.forEach((detail) => {
        postData.purchase_plan_details.push(
          {
            "id": detail.id,
            "standard_detail_id": detail.standard_detail_id,
            "quantity": detail.quantity,
            "memo": detail.memo
          }
        )
      });
      return postData;
    },

    doSubmit() {
      this.$store.dispatch("fullscreenLoading");
      PurchasePlans.edit(this.purchasePlan.id, this.doSubmitData())
        .then(
          function (response) {
            if (response.data.status.isOK()) {
              this.$router.push("/purchase-plans");
            }
            this.$snackbar.success(i18n.t("PurchasePlans.editSuccess"));
            this.$store.dispatch("fullscreenLoadingStop");
          }.bind(this)
        )
        .catch(
          function () {
            this.$store.dispatch("fullscreenLoadingStop");
          }.bind(this)
        );
    },
  },

  watch: {
    purchasePlan: {
      deep: true,
      handler() {
        // 计算损耗浮动百分比
        if (this.purchasePlan) {
          this.purchasePlan.purchase_plan_details.forEach((detail) => {
            detail.quantity = parseFloat(Number(detail.quantity).toFixed(2))
          });
        }
      },
    },
  },
};
</script>